import { Injectable } from '@angular/core';
import {
  IProductListOpenedEvent,
  ProductListAnalyticsEvent,
} from '@epicuro-next/platform/event-tracker';
import { selectActiveAccountId } from '@epicuro-next/state/accounts-state';
import { trackEvent } from '@epicuro-next/state/event-tracker';
import { selectListEntity } from '@epicuro-next/state/list-entities';
import { selectUser } from '@epicuro-next/state/user-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import {
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  take,
  withLatestFrom,
} from 'rxjs/operators';

import * as actions from '../../actions';
import { ITrackList } from '../../models';

@Injectable()
export class TrackListEffects {
  private user$ = this.store.pipe(select(selectUser), filter(isNonNullish));
  private accountId$ = this.store.pipe(
    select(selectActiveAccountId),
    filter(isNonNullish),
  );

  constructor(private actions$: Actions, private store: Store) {}

  public trackList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.trackList),
      distinctUntilChanged(
        ({ payload: prevPayload }, { payload: currPayload }) =>
          this.isDifferentEvent(prevPayload, currPayload),
      ),
      switchMap(({ payload }) =>
        this.store.pipe(
          select(selectListEntity, payload.productListId),
          filter(isNonNullish),
          filter((entity) => !entity?.loading),
          withLatestFrom(this.user$, this.accountId$),
          take(1),
          map(([entity, user, accountId]) => {
            const event: IProductListOpenedEvent = {
              name: ProductListAnalyticsEvent.ProductListOpened,
              properties: {
                userId: user.userId,
                externalUserId: user.externalId,
                accountId,
                externalOwnerId: entity?.list?.creation?.user
                  ?.externalId as string,
                ownerId: entity?.list?.creation?.user?.externalId as string,
                source: payload.source,
                productListId: payload.productListId,
              },
            };
            return trackEvent({
              event,
            });
          }),
        ),
      ),
    ),
  );

  public isDifferentEvent(prev: ITrackList, curr: ITrackList) {
    return (
      prev.productListId === curr.productListId && prev.source === curr.source
    );
  }
}
